import { Navigate, Route, Routes } from 'react-router-dom'
import ViemaxProgramHome from './Home'
import ExtendPlan from './ExtendPlan'

const ViemaxRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="home" />} />
      <Route path="home" Component={ViemaxProgramHome} />
      <Route path="extend-plan" Component={ExtendPlan} />
    </Routes>
  )
}

export default ViemaxRoutes
